var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.076,
    height: 73.507,
    viewBox: "0 0 65.076 73.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17955",
    "data-name": "Grupo 17955",
    transform: "translate(-653.456 -256.993)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1708",
    "data-name": "Elipse 1708",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(688.532 256.993)",
    fill: "#7eccc9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1285_",
    transform: "translate(574.67 250.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1282_",
    transform: "translate(90.001 33.594)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_325_",
    width: 29.146,
    height: 44.413,
    fill: "#fec4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1284_",
    transform: "translate(80.286 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_326_",
    d: "M150.657,181.842H110.408V134.637a4.147,4.147,0,0,1,4.147-4.147H146.51a4.147,4.147,0,0,1,4.147,4.147Z",
    transform: "translate(-106.244 -113.835)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_324_",
    x2: 48.577,
    transform: "translate(0 68.007)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_323_",
    width: 18.043,
    height: 13.879,
    transform: "translate(15.267 29.146)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_287_",
    y2: 2.776,
    transform: "translate(15.267 49.965)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitDoor);
export default __webpack_public_path__ + "static/media/exit_door.8e7242e42a5288ffecb1212ff1dc761d.svg";
export { ForwardRef as ReactComponent };